module.exports = __webpack_public_path__ + "img/header-diamondJewelryPresentsWomen.c7b8479.jpg";